import isDonationField from './isDonationField';

// Sorts Advanced Filter fields so that constituent fields come before
// contribution fields.

const sortFilterFields = (fields: string[]) =>
  fields
    .reduce<string[][]>(
      ([constituent, contribution], val) => {
        if (isDonationField(val)) {
          return [constituent, [...contribution, val]];
        }
        return [[...constituent, val], contribution];
      },
      [[], []],
    )
    .flat();

export default sortFilterFields;
